import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { ApplicationScreen } from '@/modules/platform/admin/presentation/screens/Application';
import { ApplicationsScreen } from '@/modules/platform/admin/presentation/screens/Applications';
import { OrganizationScreen } from '@/modules/platform/admin/presentation/screens/Organization';
import { OrganizationsScreen } from '@/modules/platform/admin/presentation/screens/Organizations';
import { HomeScreen } from '@/modules/platform/presentation/screens/Home';
import { CreateInvitationScreen } from '@/modules/recognition/admin/presentation/screens/Invitation/CreateInvitation/CreateInvitation';
import { InvitationsScreen } from '@/modules/recognition/admin/presentation/screens/Invitation/Invitations';
import { RolesScreen } from '@/modules/recognition/admin/presentation/screens/Roles';
import { ScopesScreen } from '@/modules/recognition/admin/presentation/screens/Scopes';
import { CreateSSOScreen } from '@/modules/recognition/admin/presentation/screens/SSO/CreateSSORegistration';
import { SSORegistrationsScreen } from '@/modules/recognition/admin/presentation/screens/SSO/SSORegistrations';
import { UserScreen } from '@/modules/recognition/admin/presentation/screens/User';
import { UsersScreen } from '@/modules/recognition/admin/presentation/screens/Users';
import { BasicInfoScreen } from '@/modules/recognition/presentation/screens/AccountManagement/BasiInfo';
import { ChangePasswordScreen } from '@/modules/recognition/presentation/screens/AccountManagement/ChangePassword';
import { Layout as AccountManagement } from '@/modules/recognition/presentation/screens/AccountManagement/Layout';
import { SignInScreen } from '@/modules/recognition/presentation/screens/SignIn';
import { ResetPass } from '@/modules/recognition/presentation/screens/SignIn/components/forget-pass-flow/ResetPass';
import { SignUpScreen } from '@/modules/recognition/presentation/screens/SignUp';
import { SignInWithSSOScreen } from '@/modules/recognition/presentation/screens/SSO/SignInWithSSO';
import { Layout as AdminLayout } from '@/shared/presentation/components/admin/Layout';
import { Layout as LoggedLayout } from '@/shared/presentation/components/Layout';

import { FullPageError } from './components/FullPageError';
import AnalyticsPageViewProvider from './providers/AnalyticsPageViewProvider';

export const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <AnalyticsPageViewProvider />
      <Routes>
        <Route element={<LoggedLayout />}>
          <Route path="/" element={<HomeScreen />} />
        </Route>

        {/* Platform */}
        <Route element={<AdminLayout />}>
          <Route path="/admin/" element={<OrganizationsScreen />} />
          <Route path="/admin/organizations" element={<OrganizationsScreen />} />
          <Route path="/admin/organizations/:guid" element={<OrganizationScreen />} />
          <Route path="/admin/applications" element={<ApplicationsScreen />} />
          <Route path="/admin/applications/:guid" element={<ApplicationScreen />} />
        </Route>

        {/* Recognition */}
        <Route element={<AdminLayout />}>
          <Route path="/admin/" element={<OrganizationsScreen />} />
          <Route path="/admin/roles" element={<RolesScreen />} />
          <Route path="/admin/accounts" element={<UsersScreen />} />
          <Route path="/admin/accounts/:registrationCode" element={<UserScreen />} />
          <Route path="/admin/scopes" element={<ScopesScreen />} />
          <Route path="/admin/invitations" element={<InvitationsScreen />} />
          <Route path="/admin/invitations/create" element={<CreateInvitationScreen />} />

          {/* SSO */}
          <Route path="/admin/sso/registrations" element={<SSORegistrationsScreen />} />
          <Route path="/admin/sso/registrations/create" element={<CreateSSOScreen />} />
        </Route>

        {/* Auth */}
        <Route path="/signup" element={<SignUpScreen />} />
        <Route path="/signin" element={<SignInScreen />} />
        <Route path="/reset-password" element={<ResetPass />} />

        {/* SSO */}
        <Route path="/sso/:provider" element={<SignInWithSSOScreen />} />

        {/* Account Management */}
        <Route element={<LoggedLayout />}>
          <Route path="account" element={<AccountManagement />}>
            <Route index element={<BasicInfoScreen />} />
            <Route path="password" element={<ChangePasswordScreen />} />
          </Route>
        </Route>

        <Route path="*" element={<FullPageError errorMessage="404 - Página não encontrada" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
